import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState } from 'react';
import { AppBar, IconButton, Container, useMediaQuery, Grid, Popover, TAGLink, TAGOutlinedButton } from '../../../..';
import { Menu, Close } from '@mui/icons-material';
import { MOTTO_COLOR } from '../../../../constants/constant';

var MottoHeader = function MottoHeader(props) {
  var _useState = useState({
    anchorElNav: null,
    showSearchInputField: false,
    searchInputValue: ''
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var contentfulData = props.contentfulData;
  var navigationItems = contentfulData.header.navigationLinks;
  var applicationName = contentfulData.name;
  var logoUrl = contentfulData.logo.file.url;
  var isMenuOpen = Boolean(state.anchorElNav);
  var isMottoScheduling = applicationName === 'Motto - Scheduling';
  var isMediumAndAboveDevice = useMediaQuery('(min-width: 768px)');
  var isLargeDevice = useMediaQuery('(max-width: 992px)');
  var mottoImageWidth = isMediumAndAboveDevice ? isMottoScheduling ? '153px' : '92px' : '90px';

  var handleOpenNavMenu = function handleOpenNavMenu(event) {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      anchorElNav: event.currentTarget
    }));
  };

  var handleCloseNavMenu = function handleCloseNavMenu() {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      anchorElNav: null
    }));
  };

  return React.createElement(AppBar, {
    position: "static",
    sx: {
      backgroundColor: MOTTO_COLOR.neutrals.white,
      height: isMediumAndAboveDevice ? 88 : 64,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React.createElement(Container, null, React.createElement(Grid, {
    container: true,
    alignItems: "center",
    wrap: "nowrap",
    justifyContent: isLargeDevice && isMottoScheduling ? 'center' : 'flex-start'
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(TAGLink, {
    href: "/"
  }, React.createElement("img", {
    src: logoUrl,
    width: mottoImageWidth,
    height: "unset"
  }))), isMottoScheduling ? null : // This non scheduling  motto header will be revisited
  React.createElement(Grid, {
    item: true,
    container: true,
    alignItems: "center",
    spacing: 2,
    justifyContent: "flex-end"
  }, isMediumAndAboveDevice ? React.createElement(React.Fragment, null, navigationItems.map(function (navigationItem) {
    return React.createElement(Grid, {
      item: true,
      key: navigationItem.id
    }, React.createElement(TAGLink, {
      key: navigationItem.id,
      href: navigationItem.path,
      color: "secondary"
    }, navigationItem.breadcrumbTitle || navigationItem.title));
  }), React.createElement(Grid, {
    item: true
  }, React.createElement(TAGOutlinedButton, null, "Book now"))) : React.createElement(React.Fragment, null, React.createElement(Grid, {
    item: true
  }, React.createElement(TAGOutlinedButton, null, "Book now")), React.createElement(Grid, {
    item: true
  }, React.createElement(IconButton, {
    size: "large",
    "aria-label": "account of current user",
    "aria-controls": "menu-appbar",
    "aria-haspopup": "true",
    onClick: handleOpenNavMenu,
    color: "secondary"
  }, isMenuOpen ? React.createElement(Close, null) : React.createElement(Menu, null)))))), React.createElement(Popover, {
    id: "menu-appbar",
    anchorEl: state.anchorElNav,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    marginThreshold: 0,
    open: isMenuOpen,
    onClose: handleCloseNavMenu,
    PaperProps: {
      style: {
        width: '100%',
        backgroundColor: MOTTO_COLOR.neutrals.white,
        padding: '35px 16px',
        borderRadius: 0,
        boxShadow: 'none'
      }
    }
  }, React.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 5
  }, navigationItems.map(function (navigationItem) {
    return React.createElement(Grid, {
      item: true,
      key: navigationItem.id
    }, React.createElement(TAGLink, {
      key: navigationItem.id,
      href: navigationItem.path,
      color: "secondary"
    }, navigationItem.breadcrumbTitle || navigationItem.title));
  })))));
};

export default MottoHeader;